import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "footer" }

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "footer__inner" }, [
      _createElementVNode("p", { class: "footer__names" }, " Elena & Antoine "),
      _createElementVNode("p", { class: "footer__date" }, " 13 juin 2026 ")
    ], -1 /* CACHED */)
  ]))]))
}